import * as types from "../mutation-types";
import {resetStoreState} from "@/store/storeUtils";
import {enumDef} from "@/common/enumDefs";

const defaultState = {
    version: {
        id: "",
        outdated: false,
    },
    searchData: "",
    isLoggedIn: false,
    currentLang: enumDef.language.DE,
    carePhoneNumber: "+49 (0)40 257 660 650",
    careEmail: "contact_us@tnp.ai",
    // For security reasons we do not store credentials in a persistent storage
    signUp: {
        signUpCredentials: {
            userPassword: "",
            userPasswordRepeat: "",
        }
    },
    registerData: {
        captcha: "",
        companyLegalStructureId: "",
        companyName: "",
        companyRegisterCourtId: "",
        companyRegistrationNumber: "",
        companyTaxNumber: "",
        country: "",
        invitationCode: "",
        partnerCustomerId: "",
        redirectUrl: "",
        invitationCodeSetAutomatically: false,
        userEmail: "",
        userFirstName: "",
        userLastName: "",
        userPassword: "",
        userPasswordRepeat: "",
        userPhone: "",
        userPosition: ""
    },
    step: 0,
    pdfDialogShow: false,
    noticeModalShow: false,
    noticeModalData: {
        title: "",
        data: {}
    },
    tableItemData: {},
    dashboardFilter: {
        type: 'seller', //seller,buyer
        accountId: '', //for buyer
        accountCurrency: '',//for buyer
        years: '',
        currency: '',//for buyer
    },
    dashboardInfo: {},
    redirect: {
        name: "",
        url: ""
    },
    currencyExchangeRates: [],
    auctionConfig: {}
};

const state = {
    ...defaultState
};

const getters = {
    getExchangeRateBySrcAndDstCurrency: (state) => (srcCurrency, dstCurrency) => {
        let rate = state.currencyExchangeRates.find(rate => rate.srcCurrency === srcCurrency && rate.dstCurrency === dstCurrency);
        if (rate) {
            return rate.rate;
        }
        this.toast("Error: no rate");
    },
    auctionConfig: state => state.auctionConfig,
    version: state => state.version,
    searchData: state => state.searchData,
    isLoggedIn: state => state.isLoggedIn,
    carePhoneNumber: state => state.carePhoneNumber,
    careEmail: state => state.careEmail,
    currentLang: state => state.currentLang,
    registerData: state => state.registerData,
    step: state => state.step,
    pdfDialogShow: state => state.pdfDialogShow,
    noticeModalShow: state => state.noticeModalShow,
    noticeModalData: state => state.noticeModalData,
    tableItemData: state => state.tableItemData,
    dashboardFilter: state => state.dashboardFilter,
    dashboardInfo: state => state.dashboardInfo,
    redirect: state => state.redirect,
    signUpCredentials: state => state.signUp.signUpCredentials,
};

const actions = {
    setActionExchangeRates({
        commit
    }, payload) {
        commit(types.CURRENCY_EXCHANGE_RATES, payload);
    },
    setActionAuctionConfig({
        commit
    }, payload) {
        commit(types.AUCTION_CONFIG, payload);
    },
    setActionLoggedIn({
        commit
    }, payload) {
        commit(types.SET_LOGGED_IN, payload);
    },
    setActionNoticModal({
        commit
    }, payload) {
        commit(types.NOTICE_MODAL, payload);
    },
    setActionPdfDialog({
        commit
    }, payload) {
        commit(types.PDF_DIALOG, payload);
    },
    setActionSearchData({
        commit
    }, payload) {
        commit(types.SEARCH_DATA, payload);
    },
    saveActionRegisterData({
        commit
    }, payload) {
        commit(types.FORME_DATA, payload);
    },
    setActionDashboardFilter({
        commit
    }, payload) {
        commit(types.SET_DASHBOARD, payload);
    },
    setActionDashboardInfo({
        commit
    }, payload) {
        commit(types.SET_DASHBOARD_INFO, payload);
    },
    setRedirect({
        commit
    }, payload) {
        commit(types.SET_REDIRECT, payload);
    },
    clearRedirect({
        commit
    }) {
        commit(types.CLEAR_REDIRECT);
    },
    setSignUpCredentials({
        commit
    }, payload) {
        commit(types.SET_SIGN_UP_CREDENTIALS, payload)
    }
};

const mutations = {
    [types.SET_LOGGED_IN](state, payload) {
        state.isLoggedIn = payload
    },
    [types.SET_DASHBOARD_INFO](state, payload) {
        state.dashboardInfo = payload
    },
    [types.SET_DASHBOARD](state, payload) {
        state.dashboardFilter = {
            ...state.dashboardFilter,
            ...payload
        }
    },
    [types.SET_REDIRECT](state, payload) {
        state.redirect = {
            ...state.redirect,
            ...payload
        }
    },
    [types.CLEAR_REDIRECT](state) {
        state.redirect = {
            ...defaultState.redirect
        }
    },
    [types.NOTICE_MODAL](state, payload) {
        state.noticeModalShow = payload.show;
        state.noticeModalData = payload.data;
    },
    [types.PDF_DIALOG](state, payload) {
        state.pdfDialogShow = payload.show;
        if (payload.data) {
            state.tableItemData = payload.data
        } else {
            state.tableItemData = {}

        }
    },
    [types.SEARCH_DATA](state, payload) {
        state.searchData = {
            ...state.searchData,
            ...payload
        };
    },
    [types.FORME_DATA](state, payload) {
        if (payload && payload.type === "reset") {
            state.registerData = defaultState.registerData
        } else {
            state.registerData = {
                ...state.registerData,
                ...payload
            };
        }
    },
    [types.SET_SIGN_UP_CREDENTIALS](state, payload) {
        state.signUp.signUpCredentials = payload;
    },
    [types.CURRENCY_EXCHANGE_RATES](state, payload) {
        state.currencyExchangeRates = payload
    },
    [types.AUCTION_CONFIG](state, payload) {
        state.auctionConfig = payload
    },
    initBaseState(state) {
        resetStoreState(state, defaultState, ["version.id"]);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};